import { DateTime } from 'luxon';

import FeatureFee, { IFeatureFeeAPI } from '@/common/models/FeatureFee';
import Validatable from '@/validator/Validatable';

interface IFeatureFeesAPI {
  organization_id: number;
  utc_date: string;
  feature_values: IFeatureFeeAPI[];
}

export default class FeatureFees extends Validatable<FeatureFees> {
  constructor(
    public organizationID: number = undefined,
    public features: FeatureFee[] = [],
    public utcDate: DateTime = DateTime.local(),
  ) {
    super();
  }

  static fromObject(obj: object) {
    return super.fromObject(obj, new FeatureFees());
  }

  static fromApi(apiObject: IFeatureFeesAPI) {
    return new FeatureFees(
      apiObject.organization_id,
      apiObject.feature_values ? apiObject.feature_values.map((f) => FeatureFee.fromApi(f)) : [],
      apiObject.utc_date ? DateTime.fromISO(apiObject.utc_date, { zone: 'utc' }) : undefined,
    );
  }
}
